import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { getStoryBySlug } from "@cinch-nx/data-storyblok";
import { setTag, traceFunction } from "@core/datadog-server";
function getStaticPropsfn(_) {
    return _getStaticPropsfn.apply(this, arguments);
}
function _getStaticPropsfn() {
    _getStaticPropsfn = _async_to_generator(function(param) {
        var _preview, preview, ref, ref1, story, HeroProps;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _preview = param.preview, preview = _preview === void 0 ? false : _preview;
                    return [
                        4,
                        getStoryBySlug("app", {
                            version: preview ? "draft" : "published"
                        })
                    ];
                case 1:
                    story = _state.sent();
                    setTag("page.name", "app");
                    setTag("page.status-code", "200");
                    setTag("page.rendered", "ISR");
                    setTag("page.revalidate-in", "300s");
                    setTag("page.params", JSON.stringify({
                        preview: preview
                    }, null, 2));
                    HeroProps = story === null || story === void 0 ? void 0 : (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.hero) === null || ref1 === void 0 ? void 0 : ref1[0];
                    return [
                        2,
                        {
                            props: {
                                story: story,
                                preview: preview,
                                generatedAt: Date.now(),
                                layoutProps: {
                                    heroProps: HeroProps,
                                    showBorderRadius: false
                                }
                            },
                            revalidate: 300
                        }
                    ];
            }
        });
    });
    return _getStaticPropsfn.apply(this, arguments);
}
export var getStaticProps = traceFunction("mobile-app.getStaticProps", getStaticPropsfn);
